<template lang="pug">
  v-textarea(:value="value" :label="label" light @input="handleInput" outlined)
</template>

<script>
export default {
  name: 'app-textarea',
  props: {
    value: [String, Number],
    label: {
      type: String,
      default: 'Комментарий'
    },
  },
  methods: {
    handleInput (event) {
      this.$emit('input', event)
    }
  }
}
</script>
